import BaseApi from "apps/visits/lib/BaseApi";
import { createRoute } from "apps/visits/packages/shared/models/Route";
import { HTTPMethods } from "apps/visits/packages/shared/static/http-methods";

export type OrderConfirmationParams = { slug: string; token: string };

export type OrderConfirmationStatusResponse = Record<string, never>;

export const orderConfirmationRoutes = {
  getStatus: createRoute<OrderConfirmationParams>(
    "/api/v2/vouchers_ordering/vouchers_distributions/:slug/order_confirmations/:token",
  ),
  getDownload: createRoute<OrderConfirmationParams>(
    "/api/v2/vouchers_ordering/vouchers_distributions/:slug/order_confirmations/:token/download",
  ),
};

export const buildDownloadUrl = (params: OrderConfirmationParams) => orderConfirmationRoutes.getDownload.apply(params);

export class OrderConfirmationRepository extends BaseApi {
  async getStatus({ slug, token }: OrderConfirmationParams) {
    return this.request<OrderConfirmationStatusResponse>({
      url: orderConfirmationRoutes.getStatus.apply({ slug, token }),
      method: HTTPMethods.GET,
    });
  }
}
